import service from "../utils/axios";

// 获取任务列表
const getTaskList = () => {
  return service.get("/user_center/tasks");
};

// 签到
const postSign = () => {
  return service.post("/user_center/sign");
};

// 浏览上新数据
const postUserView = () => {
  return service.post("/user_center/view");
};

// 获取个人当前竞猜数据
const getGuessCurrent = () => {
  return service.get("/user_center/guess/current");
};

// 获取个人竞猜统计数据
const getGuessStat = () => {
  return service.get("/user_center/guess/stat");
};

// 竞猜投票
const postGuessVote = (data) => {
  return service.post("/user_center/guess/vote", data);
};

// 获取个人竞猜明细列表
const getGuessVotes = (data) => {
  return service.get("/user_center/guess/votes", {
    params: data
  });
};


export {
  getTaskList,
  postSign,
  postUserView,
  getGuessCurrent,
  getGuessStat,
  postGuessVote,
  getGuessVotes
}